import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {AccountReportSelectionControlData} from "../../account/controls/account-report-selection-control.component";

export class AccItemStmtReportData extends ReportData<AccItemStmtReportData> {
    @field summary: boolean = true;
    @field showChargesAfter: boolean = true;
    @field POSTAL_ADDRESS: string = "true";
    @collection(AccountReportSelectionControlData) accounts: AccountReportSelectionControlData[];
}
